export const OfferCompareView = {
    OVERVIEW: 'overview',
    LINE_ITEMS: 'lineItems',
} as const;

export type OfferCompareViewValue = (typeof OfferCompareView)[keyof typeof OfferCompareView];
